module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加赛事")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "width:100%; height:100%;",
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getListData
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "赛事名称"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getListData($event)
      }
    },
    model: {
      value: (_vm.filters.Name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "Name", $$v)
      },
      expression: "filters.Name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "1702px"
    },
    attrs: {
      "data": _vm.List,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-table', {
          attrs: {
            "data": props.row.CompetitionGroup
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "Name",
            "label": "组名",
            "width": "120",
            "sortable": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "Type",
            "label": "组类型",
            "width": "100",
            "formatter": _vm.formatType,
            "sortable": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "ItemCount",
            "label": "项目数量",
            "width": "120",
            "sortable": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "Sex",
            "label": "性别",
            "width": "100",
            "formatter": _vm.formatSex,
            "sortable": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "StartTime",
            "label": "最小参赛生日",
            "width": "140",
            "sortable": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "EndTime",
            "label": "最大参赛生日",
            "width": "140",
            "sortable": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "State",
            "label": "状态",
            "width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "name-wrapper",
                attrs: {
                  "slot": "reference"
                },
                slot: "reference"
              }, [(scope.row.State == '1') ? _c('el-tag', {
                attrs: {
                  "type": "danger",
                  "size": "medium"
                }
              }, [_vm._v("已锁定")]) : _vm._e(), _vm._v(" "), (scope.row.State == '0' || scope.row.State == null) ? _c('el-tag', {
                attrs: {
                  "type": "warning",
                  "size": "medium"
                }
              }, [_vm._v("未锁定")]) : _vm._e()], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "Remark",
            "label": "备注",
            "width": "180",
            "sortable": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "min-width": "150",
            "fixed": "right",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-button', {
                attrs: {
                  "type": "primary",
                  "size": "small"
                },
                on: {
                  "click": function($event) {
                    _vm.handleShowItems(scope.row)
                  }
                }
              }, [_vm._v("项目管理")]), _vm._v(" "), _c('el-button', {
                attrs: {
                  "size": "small"
                },
                on: {
                  "click": function($event) {
                    _vm.handleGroupEdit(scope.row)
                  }
                }
              }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
                attrs: {
                  "type": "danger",
                  "size": "small"
                },
                on: {
                  "click": function($event) {
                    _vm.handleGroupDel(scope.$index, scope.row)
                  }
                }
              }, [_vm._v("删除")])]
            }
          }])
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CompetitionTypeName",
      "label": "赛事分类",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "赛事名称",
      "width": "240",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CompetitionState",
      "label": "赛事状态",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "click"
          }
        }, [(scope.row.CompetitionState == 0) ? _c('el-tag', {
          attrs: {
            "type": "info",
            "size": "small"
          }
        }, [_vm._v("新增")]) : (scope.row.CompetitionState == 1) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "small"
          }
        }, [_vm._v("准备")]) : (scope.row.CompetitionState == 2) ? _c('el-tag', {
          attrs: {
            "type": "primary",
            "size": "small"
          }
        }, [_vm._v("发布")]) : (scope.row.CompetitionState == 3) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "small"
          }
        }, [_vm._v("报名")]) : (scope.row.CompetitionState == 4) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "small"
          }
        }, [_vm._v("报名结束")]) : (scope.row.CompetitionState == 5) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "small"
          }
        }, [_vm._v("比赛")]) : (scope.row.CompetitionState == 6) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "small"
          }
        }, [_vm._v("比赛结束")]) : (scope.row.CompetitionState == 7) ? _c('el-tag', {
          attrs: {
            "type": "blue",
            "size": "small"
          }
        }, [_vm._v("赛事完结")]) : _vm._e(), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          staticClass: "clearfix",
          nativeOn: {
            "click": function($event) {
              _vm.ChangeState(scope.row, 0)
            }
          }
        }, [_vm._v("\n                            新增\n                          ")]), _vm._v(" "), _c('el-dropdown-item', {
          staticClass: "clearfix",
          nativeOn: {
            "click": function($event) {
              _vm.ChangeState(scope.row, 1)
            }
          }
        }, [_vm._v("\n                            准备\n                         ")]), _vm._v(" "), _c('el-dropdown-item', {
          staticClass: "clearfix",
          nativeOn: {
            "click": function($event) {
              _vm.ChangeState(scope.row, 2)
            }
          }
        }, [_vm._v("\n                            发布\n                         ")]), _vm._v(" "), _c('el-dropdown-item', {
          staticClass: "clearfix",
          nativeOn: {
            "click": function($event) {
              _vm.ChangeState(scope.row, 3)
            }
          }
        }, [_vm._v("\n                            报名中\n                         ")]), _vm._v(" "), _c('el-dropdown-item', {
          staticClass: "clearfix",
          nativeOn: {
            "click": function($event) {
              _vm.ChangeState(scope.row, 4)
            }
          }
        }, [_vm._v("\n                            报名结束\n                         ")]), _vm._v(" "), _c('el-dropdown-item', {
          staticClass: "clearfix",
          nativeOn: {
            "click": function($event) {
              _vm.ChangeState(scope.row, 5)
            }
          }
        }, [_vm._v("\n                            比赛中\n                         ")]), _vm._v(" "), _c('el-dropdown-item', {
          staticClass: "clearfix",
          nativeOn: {
            "click": function($event) {
              _vm.ChangeState(scope.row, 6)
            }
          }
        }, [_vm._v("\n                            比赛结束\n                         ")]), _vm._v(" "), _c('el-dropdown-item', {
          staticClass: "clearfix",
          nativeOn: {
            "click": function($event) {
              _vm.ChangeState(scope.row, 7)
            }
          }
        }, [_vm._v("\n                            赛事完结\n                         ")])], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GroupCount",
      "label": "组数",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Number",
      "label": "队伍可报人数",
      "width": "145",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ContactName",
      "label": "联系人",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ContactNumber",
      "label": "号码",
      "width": "125",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "RegistrationStart",
      "label": "报名开始时间",
      "width": "150",
      "formatter": _vm.formatDate,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "RegistrationEnd",
      "label": "报名结束时间",
      "width": "150",
      "formatter": _vm.formatDate,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "StartTime",
      "label": "比赛开始时间",
      "width": "150",
      "formatter": _vm.formatDate,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "EndTime",
      "label": "比赛结束时间",
      "width": "150",
      "formatter": _vm.formatDate,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Addres",
      "label": "举办地点",
      "width": "240",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "备注",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "480",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleGroupAdd(scope.row)
            }
          }
        }, [_vm._v("新增组")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleShowEntry(scope.row)
            }
          }
        }, [_vm._v("报名信息")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.achievementmanage(scope.row)
            }
          }
        }, [_vm._v("成绩管理")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.ShowExport(scope.row)
            }
          }
        }, [_vm._v("导出管理")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-tag', [_vm._v("当前有" + _vm._s(_vm.Count) + "个赛事")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "id": "tt",
      "title": "成绩上传"
    },
    model: {
      value: (_vm.uploadFileVisible),
      callback: function($$v) {
        _vm.uploadFileVisible = $$v
      },
      expression: "uploadFileVisible"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": "",
      "http-request": _vm.upload,
      "multiple": "",
      "customClass": ".el-upload-dragger"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("上传PDF成绩文件")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "成绩管理",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.achievementmanageVisivle),
      callback: function($$v) {
        _vm.achievementmanageVisivle = $$v
      },
      expression: "achievementmanageVisivle"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadPDF
    }
  }, [_vm._v("上传成绩pdf")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.achienementList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "FileName",
      "label": "文件名",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CreationTime",
      "label": "添加时间",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.FileDown(scope.row)
            }
          }
        }, [_vm._v("下载成绩单")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.FileDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "下载报表管理",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.exportVisivle),
      callback: function($$v) {
        _vm.exportVisivle = $$v
      },
      expression: "exportVisivle"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.ExportReport()
      }
    }
  }, [_vm._v("报名表")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.WordFileDown()
      }
    }
  }, [_vm._v("代表队人数统计")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.RosterFileDown()
      }
    }
  }, [_vm._v("代表队名单")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "赛事分类",
      "prop": "CompetitionTypeId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择赛事分类"
    },
    model: {
      value: (_vm.editForm.CompetitionTypeId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "CompetitionTypeId", $$v)
      },
      expression: "editForm.CompetitionTypeId"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赛事名称",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.Name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Name", $$v)
      },
      expression: "editForm.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赛事联系人",
      "prop": "ContactName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.ContactName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "ContactName", $$v)
      },
      expression: "editForm.ContactName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系号码",
      "prop": "ContactNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.ContactNumber),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "ContactNumber", $$v)
      },
      expression: "editForm.ContactNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "队伍可报人数",
      "prop": "Number"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.Number),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Number", $$v)
      },
      expression: "editForm.Number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "报名开始时间",
      "prop": "RegistrationStart"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.editForm.RegistrationStart),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "RegistrationStart", $$v)
      },
      expression: "editForm.RegistrationStart"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "报名结束时间",
      "prop": "RegistrationEnd"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.editForm.RegistrationEnd),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "RegistrationEnd", $$v)
      },
      expression: "editForm.RegistrationEnd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "比赛开始时间",
      "prop": "StartTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.editForm.StartTime),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "StartTime", $$v)
      },
      expression: "editForm.StartTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "比赛结束时间",
      "prop": "EndTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.editForm.EndTime),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "EndTime", $$v)
      },
      expression: "editForm.EndTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "举办地点",
      "prop": "Addres"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.Addres),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Addres", $$v)
      },
      expression: "editForm.Addres"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editForm.Remark),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Remark", $$v)
      },
      expression: "editForm.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "120px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "赛事分类",
      "prop": "CompetitionTypeId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择赛事分类"
    },
    model: {
      value: (_vm.addForm.CompetitionTypeId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "CompetitionTypeId", $$v)
      },
      expression: "addForm.CompetitionTypeId"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赛事名称",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.Name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Name", $$v)
      },
      expression: "addForm.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赛事联系人",
      "prop": "ContactName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.ContactName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "ContactName", $$v)
      },
      expression: "addForm.ContactName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系号码",
      "prop": "ContactNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.ContactNumber),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "ContactNumber", $$v)
      },
      expression: "addForm.ContactNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "队伍可报人数",
      "prop": "Number"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.Number),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Number", $$v)
      },
      expression: "addForm.Number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "报名开始时间",
      "prop": "RegistrationStart"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.addForm.RegistrationStart),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "RegistrationStart", $$v)
      },
      expression: "addForm.RegistrationStart"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "报名结束时间",
      "prop": "RegistrationEnd"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.addForm.RegistrationEnd),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "RegistrationEnd", $$v)
      },
      expression: "addForm.RegistrationEnd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "比赛开始时间",
      "prop": "StartTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.addForm.StartTime),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "StartTime", $$v)
      },
      expression: "addForm.StartTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "比赛结束时间",
      "prop": "EndTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.addForm.EndTime),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "EndTime", $$v)
      },
      expression: "addForm.EndTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "举办地点",
      "prop": "Addres"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.Addres),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Addres", $$v)
      },
      expression: "addForm.Addres"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.addForm.Remark),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Remark", $$v)
      },
      expression: "addForm.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增组",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addGroupVisible),
      callback: function($$v) {
        _vm.addGroupVisible = $$v
      },
      expression: "addGroupVisible"
    }
  }, [_c('el-form', {
    ref: "GroupFrom",
    attrs: {
      "model": _vm.addGroup,
      "label-width": "130px",
      "rules": _vm.addGroupRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "组类别",
      "prop": "Type"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addGroup.Type),
      callback: function($$v) {
        _vm.$set(_vm.addGroup, "Type", $$v)
      },
      expression: "addGroup.Type"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("团体项目")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("个人项目")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "组名称",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addGroup.Name),
      callback: function($$v) {
        _vm.$set(_vm.addGroup, "Name", $$v)
      },
      expression: "addGroup.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addGroup.Sex),
      callback: function($$v) {
        _vm.$set(_vm.addGroup, "Sex", $$v)
      },
      expression: "addGroup.Sex"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("女")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 2
    }
  }, [_vm._v("混合")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "参赛出生日期"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "align": "left"
    },
    model: {
      value: (_vm.addGroup.dateValue),
      callback: function($$v) {
        _vm.$set(_vm.addGroup, "dateValue", $$v)
      },
      expression: "addGroup.dateValue"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.addGroup.Remark),
      callback: function($$v) {
        _vm.$set(_vm.addGroup, "Remark", $$v)
      },
      expression: "addGroup.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addGroupVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addGroupSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑组",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editGroupVisible),
      callback: function($$v) {
        _vm.editGroupVisible = $$v
      },
      expression: "editGroupVisible"
    }
  }, [_c('el-form', {
    ref: "editGroupFrom",
    attrs: {
      "model": _vm.editGroup,
      "label-width": "130px",
      "rules": _vm.editGroupRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "组类别",
      "prop": "Type"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editGroup.Type),
      callback: function($$v) {
        _vm.$set(_vm.editGroup, "Type", $$v)
      },
      expression: "editGroup.Type"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("团体项目")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("个人项目")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "组名称",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editGroup.Name),
      callback: function($$v) {
        _vm.$set(_vm.editGroup, "Name", $$v)
      },
      expression: "editGroup.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editGroup.Sex),
      callback: function($$v) {
        _vm.$set(_vm.editGroup, "Sex", $$v)
      },
      expression: "editGroup.Sex"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("女")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 2
    }
  }, [_vm._v("混合")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "参赛出生日期"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "align": "left"
    },
    model: {
      value: (_vm.editGroup.dateValue),
      callback: function($$v) {
        _vm.$set(_vm.editGroup, "dateValue", $$v)
      },
      expression: "editGroup.dateValue"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editGroup.Remark),
      callback: function($$v) {
        _vm.$set(_vm.editGroup, "Remark", $$v)
      },
      expression: "editGroup.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editGroupVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editGroupSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑项目",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editItemsVisible),
      callback: function($$v) {
        _vm.editItemsVisible = $$v
      },
      expression: "editItemsVisible"
    }
  }, [_c('el-form', {
    ref: "editItems",
    attrs: {
      "model": _vm.editItems,
      "label-width": "120px",
      "rules": _vm.editItemsRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目泳姿",
      "prop": "CompetitionPostureId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择泳姿"
    },
    on: {
      "change": function($event) {
        _vm.selectChange($event, 'edit')
      }
    },
    model: {
      value: (_vm.editItems.CompetitionPostureId),
      callback: function($$v) {
        _vm.$set(_vm.editItems, "CompetitionPostureId", $$v)
      },
      expression: "editItems.CompetitionPostureId"
    }
  }, _vm._l((_vm.postureOption), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name + ' ' + item.Distance,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "项目名称",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editItems.Name),
      callback: function($$v) {
        _vm.$set(_vm.editItems, "Name", $$v)
      },
      expression: "editItems.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editItems.Remark),
      callback: function($$v) {
        _vm.$set(_vm.editItems, "Remark", $$v)
      },
      expression: "editItems.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editItemsVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editItemSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增项目",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addItemsVisible),
      callback: function($$v) {
        _vm.addItemsVisible = $$v
      },
      expression: "addItemsVisible"
    }
  }, [_c('el-form', {
    ref: "addItems",
    attrs: {
      "model": _vm.addItems,
      "label-width": "120px",
      "rules": _vm.addItemsRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目泳姿",
      "prop": "CompetitionPostureId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择泳姿"
    },
    on: {
      "change": function($event) {
        _vm.selectChange($event, 'add')
      }
    },
    model: {
      value: (_vm.addItems.CompetitionPostureId),
      callback: function($$v) {
        _vm.$set(_vm.addItems, "CompetitionPostureId", $$v)
      },
      expression: "addItems.CompetitionPostureId"
    }
  }, _vm._l((_vm.postureOption), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name + ' ' + item.Distance,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "项目名称",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addItems.Name),
      callback: function($$v) {
        _vm.$set(_vm.addItems, "Name", $$v)
      },
      expression: "addItems.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.addItems.Remark),
      callback: function($$v) {
        _vm.$set(_vm.addItems, "Remark", $$v)
      },
      expression: "addItems.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addItemsVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addItemSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.GroupItemNameTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.groupItemsVisible),
      callback: function($$v) {
        _vm.groupItemsVisible = $$v
      },
      expression: "groupItemsVisible"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("新增项目")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.groupItemsTable,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "项目名称",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CompetitionPostureName",
      "label": "泳姿名称",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Distance",
      "label": "距离",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "备注",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "State",
      "label": "项目状态",
      "width": "120",
      "sortable": "",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.State == '1') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "medium"
          }
        }, [_vm._v("已锁定")]) : _vm._e(), _vm._v(" "), (scope.row.State == '0' || scope.row.State == null) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "medium"
          }
        }, [_vm._v("未锁定")]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "140",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleItemEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleItemDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-tag', [_vm._v("共有" + _vm._s(_vm.groupItemsCount) + "个比赛项目")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "报名人员",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.peopleVisible),
      callback: function($$v) {
        _vm.peopleVisible = $$v
      },
      expression: "peopleVisible"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "width:100%; height:100%;",
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getEntry
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "人员名称"
    },
    model: {
      value: (_vm.filters.PeopleName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "PeopleName", $$v)
      },
      expression: "filters.PeopleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "单位名称"
    },
    model: {
      value: (_vm.filters.TeamName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "TeamName", $$v)
      },
      expression: "filters.TeamName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "选择组类型"
    },
    model: {
      value: (_vm.filters.GroupType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "GroupType", $$v)
      },
      expression: "filters.GroupType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "普通",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "接力组",
      "value": "1"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.Loading),
      expression: "Loading"
    }],
    attrs: {
      "data": _vm.PeopleList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "CompetitionTeamName",
      "label": "单位",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IdentityName",
      "label": "身份",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "姓名",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Sex",
      "label": "性别",
      "width": "100",
      "formatter": _vm.formatSex,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IDNumber",
      "label": "证件号",
      "width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Coache",
      "label": "教练",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CompetitionPostureName",
      "label": "泳式",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Birthday",
      "label": "出生日期",
      "min-width": "180",
      "formatter": _vm.formatEntryDate,
      "sortable": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-tag', [_vm._v("当前共" + _vm._s(_vm.PeopleCount) + "条报名信息")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.PeopleCount
    },
    on: {
      "current-change": _vm.handleCurrentChange1
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65b11cae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Competition/Competition.vue
// module id = 1376
// module chunks = 1